import { useRef } from 'react';
import classnames from 'classnames/bind';
import { ArrowDropDownIcon } from 'tuui';
import { useOnClickOutside } from 'taboola-ultimate-ui';
import { Dotdotdot } from 'taboola-ultimate-ui';
import { useNodeWindowOverflow } from '../../hooks/useNodeWindowOverflow';
import { pickerDropdownSafePadding, pickerDropdownWidth } from '../commonPickerDropdownStyle';
import styles from './BreadcrumbsPickerStep.module.scss';

const classNameBuilder = classnames.bind(styles);

export const BreadcrumbsPickerStep = ({
    label,
    value,
    children,
    isOpen,
    openDropdown,
    closeDropdown,
    alignmentTrigger,
    dataAutomationId,
}) => {
    const ref = useRef();

    useOnClickOutside(ref, closeDropdown);

    const { containerRef, overflowWidth } = useNodeWindowOverflow({
        trigger: alignmentTrigger,
        requiredWidth: pickerDropdownWidth,
    });

    return (
        <div className={styles['container']} ref={containerRef} data-automation={dataAutomationId}>
            <div className={styles['label']}>{label}</div>
            <div className={classNameBuilder('value-container', { open: isOpen })} onClick={openDropdown}>
                <div className={styles['value']}>
                    <Dotdotdot lines={1} className={styles['value-dots']}>
                        {value}
                    </Dotdotdot>
                </div>
                <ArrowDropDownIcon fontSize="small" />
            </div>
            {isOpen && (
                <div
                    className={styles['dropdown']}
                    ref={ref}
                    style={overflowWidth ? { left: overflowWidth - pickerDropdownSafePadding } : {}}
                >
                    {children}
                </div>
            )}
        </div>
    );
};
